<div class="list-picker-message">
  <div class="list-picker-header">
    <div class="list-picker-header-image-container" *ngIf="listPicker?.image?.url">
      <img class="list-picker-header-image" [attr.src]="listPicker?.image?.url">
    </div>
    <span class="list-picker-header-title">{{ listPicker?.title }}</span>
  </div>
  <div class="list-picker-items">
    <div *ngFor="let item of listPicker?.listPicker?.sections[0]?.items">
      <div class="list-picker-item chat-message-{{ direction }}-item">
          <div class="list-picker-item-image-container" [ngClass]="{'image-spacing': anyItemsHaveImages}">
            <img class="list-picker-item-image" [attr.src]="item.image?.url" *ngIf="item.image?.url">
          </div>
          <span class="list-picker-item-title">{{ item.title }}</span>
        </div>
    </div>
  </div>
</div>
